let enabled = false;

export function getDebug() {
	return enabled;
}

export function setDebug(state: boolean) {
	enabled = state;
}
